// frontend/src/api/photoApi.js
const API = process.env.REACT_APP_API_BASE || "";

// 파일 + propertyId 동시 업로드 → 서버가 DB(property_photos, estate) 업데이트
export async function uploadPhoto(file, propertyId) {
  const fd = new FormData();
  fd.append("file", file);
  if (propertyId != null) fd.append("property", String(propertyId));
  const r = await fetch(`${API}/api/photo-storage`, { method: "POST", body: fd });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);

  const j = await r.json();
    // 개별 항목만 업데이트하도록, 이번 업로드의 썸네일 URL만 리턴
  return (
    j?.saved?.thumb_url ||
    j?.thumbViewUrl ||
    (j?.thumbFileId ? `https://drive.google.com/thumbnail?id=${j.thumbFileId}&sz=w800` : "")
  );
  
}

export async function setEstateThumb(estateNo, { thumb_file_id, thumb_url }) {
   // 서버는 PATCH /thumbnail, 구버전 PUT /photo-thumb 둘 다 지원
  const res = await fetch(`/api/properties/${estateNo}/thumbnail`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ thumb_file_id, thumb_url }),
  });
  const json = await res.json().catch(()=> ({}));
  if (!res.ok || json.ok === false) throw new Error(json.error || 'thumb-save-failed');
  return json;
}

// ---- gallery ----
export async function listPhotos(propertyId) {
  const r = await fetch(`/api/properties/${propertyId}/photos?ts=${Date.now()}`, { cache: "no-store" });
  if (!r.ok) throw new Error('listPhotos failed');
  const j = await r.json();
  const arr = j.photos || [];
  arr.sort((a,b)=>{
    const sa = a.sort_no ?? 9e9, sb = b.sort_no ?? 9e9;
    if (sa !== sb) return sa - sb;
    return String(a.id).localeCompare(String(b.id));
  });
  return arr;
}

export async function uploadPropertyPhoto(propertyId, file) {
  const fd = new FormData(); 
  fd.append('file', file);
  const r = await fetch(`/api/properties/${propertyId}/photos`, { method:'POST', body: fd });
  if (!r.ok) {
    const t = await r.text().catch(()=> '');
    throw new Error(`uploadPropertyPhoto failed: ${r.status} ${t}`);
  }
  return r.json(); // {ok, photo:{...}}
}

export async function deletePhoto(propertyId, photoId) {
  const r = await fetch(`/api/properties/${propertyId}/photos/${photoId}`, { method:'DELETE' });
  if (!r.ok) throw new Error('deletePhoto failed');
  return r.json();
}

export async function savePhotoOrder(propertyId, items) {
  const r = await fetch(`/api/properties/${propertyId}/photos/order`, {
    method:'PUT',
    headers:{ 'Content-Type':'application/json' },
    body: JSON.stringify({ items })
  });
  if (!r.ok) throw new Error('savePhotoOrder failed');
  return r.json();
}

export async function setCoverFromPhoto(propertyId, photoId) {
  const r = await fetch(`/api/properties/${propertyId}/photos/${photoId}/cover`, { method:'PATCH' });
  if (!r.ok) throw new Error('setCoverFromPhoto failed');
  return r.json();
}